document.addEventListener('DOMContentLoaded', () => {
  const cartPrice = document.querySelector('.cart__total .cart__total__price');
  cartPrice.setAttribute('bss-b2b-cart-total-price', '');

  const observer = new MutationObserver((MutationList) => {
    const cartPrice = document.querySelector('.cart__total .cart__total__price');
    for (let item of MutationList) {
      if (item.target.closest('.cart__price__holder')) {
        BSS_B2B.cart.fixer(BSS_B2B.shopData, false, false)
        cartPrice.setAttribute('bss-b2b-cart-total-price', '');
        BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData)
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
